import styled from 'styled-components'

export const PostularBarComponentWrapper = styled('div')`
  padding: 0px;
`
